import axios from "../config"

class OrderService{
    axios;
    constructor(){
        this.axios = axios;
    }
    getOrderById(orderId) {
      let url = `/order/${orderId}`
      return axios.get(url).then(request => request.data);
    }
    addOrder(order) {
        let url = `/order`;
        return this.axios.post(url, order).then(request => request.data);
      }
      updateOrder(order) {
        let url = `/order/${order.orderId}`;
        return this.axios.put(url, order).then(request => request.data);
      }
    getOrderList(fromDate,toDate,osId,fBId,status,riderId,allCheckBox) {
      let url = `/order/orderlist`
      return axios.get(url,{
          params:{
              fromDate,toDate,osId,fBId,status,riderId,allCheckBox
          }
      }).then(request => request.data);
    }
    deleteOrder(item) {
      let url = `order/${item.orderId}`;
      return this.axios.delete(url).then(request => request.data);
    } 
    orderDone(item) {
      let url = `order/${item.orderId}/done`;
      return this.axios.put(url).then(request => request.data);
    } 
    getOrderDetailList(page) {
        let url = `/order/itemlist`
        return axios.get(url,{
            params:{
                page
            }
        }).then(request => request.data);
      }
      getItemToAssignlList(townshipId,status,riderId,osId,page,fbId,tbId,isTrue) {
        let url = `/order/item/toassignlist`
        return axios.get(url,{
            params:{
                townshipId,status,riderId,osId,page,fbId,tbId,isTrue
            }
        }).then(request => request.data);
      }
      getItemToAssignlListSearch(searchText,page) {
        let url = `/order/item/toassignlist/search`
        return axios.get(url,{
            params:{
              searchText,page
            }
        }).then(request => request.data);
      }
      getTrackingList(fromDate,toDate,status,osId,page,riderId,tsId,inputDate,fBId,tBId,collectorOrDeliverer) {
        let url = `/order/trackinglist`
        return axios.get(url,{
            params:{
              fromDate,toDate,status,osId,
                page,riderId,tsId,inputDate,fBId,tBId,collectorOrDeliverer
            }
        }).then(request => request.data);
      }
      getTrackingListSearch(searchText,page) {
        let url = `/order/trackinglist/search`
        return axios.get(url,{
            params:{
                searchText,
                page
            }
        }).then(request => request.data);
      }
      getOverdueList(status,page,fBId,tBId) {
        let url = `/order/overduelist`
        return axios.get(url,{
            params:{
              status,page,fBId,tBId
            }
        }).then(request => request.data);
      }
      getRiderList(riderId,fbId,activeOrinactive) {
        let url = `/order/riderlist`
        return axios.get(url,{
            params:{
              riderId,fbId,activeOrinactive
            }
        }).then(request => request.data);
      }
      getOSList(fromDate,toDate,typeDate,osId,hideZero,activeOrinactive,pageId) {
        let url = `/order/oslist`
        return axios.get(url,{
            params:{
                fromDate,toDate,typeDate,osId,hideZero,activeOrinactive,pageId
            }
        }).then(request => request.data);
      }
      getItemDetailRiderList(fromDate,toDate,riderId,status,typeDate,fBId,tBId,pageId) {
        let url = `/order/item/riderlist`
        return axios.get(url,{
            params:{
              fromDate,toDate,riderId,status,typeDate,fBId,tBId,pageId
            }
        }).then(request => request.data);
      }
      getItemDetailRiderListFinished(fromDate,toDate,riderId,pageId,fBId,tBId) {
        let url = `/order/item/riderlist/finished`
        return axios.get(url,{
            params:{
              fromDate,toDate,riderId,pageId,fBId,tBId
            }
        }).then(request => request.data);
      }
      getItemDetailOSList(fromDate,toDate,osId,status,typeDate,fBId,tBId) {
        let url = `/order/item/oslist`
        return axios.get(url,{
            params:{
              fromDate,toDate, osId,status,typeDate,fBId,tBId
            }
        }).then(request => request.data);
      }
      getItemDetailOSListFinished(fromDate,toDate,osId,pageId,fBId,tBId) {
        let url = `/order/item/oslist/finished`
        return axios.get(url,{
            params:{
              fromDate,toDate,osId,pageId,fBId,tBId
            }
        }).then(request => request.data);
      }
      getItemSearchById(itemId) {
        let url = `/order/item/search`
        return axios.get(url,{
            params:{
              itemId
            }
        }).then(request => request.data);
      }
      getDailyCheckList(fromDate,toDate,riderId,osId,action,fBId) {
        let url = `/order/dailychecklist/`
        return axios.get(url,{
            params:{
                fromDate,toDate,riderId,osId,action,fBId
            }
        }).then(request => request.data);
      }
      getCheckDetailRiderList(invoiceOsId) {
        let url = `/order/checkdetail/riderlist`
        return axios.get(url,{
            params:{
              invoiceOsId
            }
        }).then(request => request.data);
      }
      getCheckDetailOSList(invoiceOsId) {
        let url = `/order/checkdetail/oslist`
        return axios.get(url,{
            params:{
              invoiceOsId
            }
        }).then(request => request.data);
      }
      saveOrderPhoto(formData,orderId){
        let url = `order/${orderId}/photo`;
        return axios.post(url, formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(request => request.data);
    }
    getOrderPhoto(orderId) {
      let url = `/order/${orderId}/photo`
      return axios.get(url).then(request => request.data);
    }
    getDailyOutIn(fromDate,toDate) {
      let url = `/order/outin`
      return axios.get(url,{
          params:{
              fromDate,toDate
          }
      }).then(request => request.data);
    }
    getOutInDetail(outInId) {
      let url = `/order/outin/detail`
      return axios.get(url,{
          params:{
            outInId
          }
      }).then(request => request.data);
    }
    updateOutInbyItemId(dto) {
      let url = `/item/outin`
      return axios.put(url,dto).then(request => request.data);
    }
    getOutInTextSearch(search) {
      let url = `/order/outin/search`
      return axios.get(url,{
          params:{
            search
          }
      }).then(request => request.data);
    }
    updateReDate(invoiceOsId,data) {
      let url = `/order/update/remitdate/${invoiceOsId}`
      return axios.put(url,data).then(request => request.data);
    } 
    updateRemittedPhoto(formData,invoiceOsId){
      let url = `order/remitphoto/${invoiceOsId}`;
      return axios.put(url, formData,
          {
              headers: {
                  'Content-Type': 'multipart/form-data'
              }
          }).then(request => request.data);
  }
  getRiderListSearch(search,tranList) {
    let url = `/order/riderlist/search/${search}`
    return axios.put(url,tranList).then(request => request.data);
  }
  getOrderListSearch(search,orderList) {
    let url = `/order/assignlist/search/${search}`
    return axios.put(url,orderList).then(request => request.data);
  }
   getOrderedCount() {
    let url = `/order/noticount`
    return axios.get(url).then(request => request.data);
  }
   updatePickupByRiderId(riderId,empty,dto) {
    let url = `order/pickup/${riderId}/${empty}`;
    return this.axios.put(url,dto).then(request => request.data);
  } 
}

const service = new OrderService();
export default service;